import {observable} from "@nx-js/observer-util";
import {ISiteChannelModel} from "../../../models/site/channel/ISiteChannelModel";
import {Services} from "../../Services";
import {ChannelService} from "../../channel/ChannelService";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {Network} from "../../../network/Network";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {AvatarService} from "../../avatar/AvatarService";
import {ChannelType} from "../../../models/channel/ChannelType";
import {ProductType} from "../../../models/product/ProductType";
import {ISiteChannelRegisterOutgoingModel} from "../../../models/site/channel/ISiteChannelRegisterOutgoingModel";
import {ErrorCode} from "../../../network/status/error/ErrorCode";
import {Resources} from "../../../resources/Resources";

export class SiteChannelService {
    public static siteChannels: ISiteChannelModel[] = observable([]);

    public static dispose(): void {
        this.siteChannels = observable([]);
    }

    public static init(): void {
        Services.beforeInit(this);
    }

    public static async findUrlConnectPartner(invitationId: string | undefined, isLogin: boolean, channelType: ChannelType, communityId?: string, component?: INetworkComponent): Promise<string> {
        let request = await Network.post(ProductType.PANEL, `/oauth/url/${channelType}/${isLogin}`,
            {
                invitationId: invitationId,
                communityId: communityId,
            }, component);

        if (request.status == HttpStatus.OK) {
            return decodeURIComponent(request.data);
        }

        return undefined;
    }

    public static async register(registerOutgoingModel: ISiteChannelRegisterOutgoingModel, component?: INetworkComponent): Promise<string> {
        Services.handleErrors(component, [
            {errorCode: ErrorCode.PARTNER_CONFING_INVALID, message: Resources.t("words.partnerConnectionFailed")},
            {errorCode: ErrorCode.PARTNER_CONFING_PERMISSIONS, message: registerOutgoingModel.channelType == ChannelType.SHOPIFY
                    ? Resources.t("words.shopifyPermissionsMessage")
                    : Resources.t("words.missingPermissions")},
        ]);
        let request = await Network.postJson(ProductType.PANEL, `/site/channel/register`, registerOutgoingModel, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    /**
     * store
     */

    public static storeAll(siteChannels: ISiteChannelModel[]): ISiteChannelModel[] {
        for (let key in siteChannels)
            siteChannels[key] = this.store(siteChannels[key]);

        return Services.storeAll(siteChannels);
    }

    public static store(siteChannel: ISiteChannelModel): ISiteChannelModel {
        if (siteChannel.avatar != undefined) {
            siteChannel.avatar = AvatarService.store(siteChannel.avatar);
        }

        siteChannel.channel = ChannelService.findById(siteChannel.channelId);
        return siteChannel;
    }
}